import { MapPin, ArrowUpRight } from "lucide-react";
import { LOCATION } from "../../content";
import { Eyebrow, Reveal } from "./Primitives";

export const Locations = () => (
  <section id="standorte" data-testid="locations-section" className="bg-ice py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:items-end lg:px-12">
      <Reveal className="lg:col-span-6">
        <Eyebrow>Standort</Eyebrow>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-navy sm:text-5xl">
          Unsere Kurse finden <span className="font-light italic text-sky-700">im Sportbad Dieburg statt.</span>
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600 md:text-lg">
          Für Familien aus Dieburg, Darmstadt und dem Landkreis Darmstadt-Dieburg. Den genauen Termin Ihres Kurses finden Sie in der Kursbuchung.
        </p>
        <a href="/schwimmkurse-dieburg" data-testid="locations-dieburg-page-link" className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-navy underline-offset-4 hover:underline">
          Alle Schwimmkurse in Dieburg im Überblick <ArrowUpRight className="h-4 w-4" />
        </a>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-6">
        <article data-testid="location-dieburg" className="border border-navy/10 bg-white p-7 sm:p-10">
          <div className="flex items-center justify-between">
            <h3 className="text-3xl font-extrabold tracking-tight text-navy">{LOCATION.pool}</h3>
            <MapPin className="h-6 w-6 text-sky-700" strokeWidth={1.5} />
          </div>
          <address className="mt-8 border-t border-navy/10 pt-6 text-lg not-italic leading-relaxed text-navy">
            {LOCATION.street}
            <br />
            {LOCATION.zip}
          </address>
          <a
            href={LOCATION.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-maps-link"
            className="group mt-8 inline-flex items-center gap-2 text-sm font-bold text-navy"
          >
            Route planen
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </article>
      </Reveal>
    </div>
  </section>
);
